import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { first, map } from 'rxjs';
import { Global } from '../../shared/interfaces/fce-interfaces.index';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  showFooter = signal<boolean>(false)

  constructor(private readonly http: HttpClient) {}

  getGlobalByQuery(queryString?: string) {
    const query = queryString ? `?${queryString}` : '';
    return this.http.get<{ data: Global }>(`${environment.apiUrl}/global${query}`).pipe(
      map((element) => element.data),
      first()
    );
  }

  setShowFooter(state: boolean){
    this.showFooter.set(state)
  }
}
